export default __webpack_public_path__ + "media/images/brands/expmessenger/services/service-08-73f6ad294e10198a9a9f214b78a3ef5a.jpg";